var React = require('react');

function Menu (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 7h5a1 1 0 1 1 0 2H6a1 1 0 1 1 0-2zm7 8h5a1 1 0 0 1 0 2h-5a1 1 0 1 1 0-2zm-7-4h12a1 1 0 0 1 0 2H6a1 1 0 1 1 0-2z","fill":"#0e0e0e","key":0}),React.createElement("rect",{"x":"0","y":"0","width":"24","height":"24","fill":"rgba(0, 0, 0, 0)","key":1})]);
}

Menu.defaultProps = {"width":"24","height":"24","preserveAspectRatio":"xMidYMid meet","viewBox":"0 0 24 24","style":{"msTransform":"rotate(360deg)","WebkitTransform":"rotate(360deg)","transform":"rotate(360deg)"}};

module.exports = Menu;

Menu.default = Menu;
